(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pr-offer-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pr-offer-description')) {
    customElements.define('pr-offer-description', class extends HTMLElement {
      connectedCallback() {
        const main = document.querySelector('pr-series-product');
        const slot = this.querySelector('[data-pr-offer-product]');
        if (!main || !slot) return;
        this.observer = new MutationObserver(() => {
          const selected = main.querySelector('.pr-main__size[aria-current="true"]');
          const id = selected?.dataset.setId;
          if (!id || id === slot.dataset.prOfferProduct) return;
          const template = main.querySelector(`template[data-set-description="${CSS.escape(id)}"]`);
          const offer = template?.content.querySelector('section[data-pr-offer="v1"]');
          slot.replaceChildren(...(offer ? [offer.cloneNode(true)] : []));
          slot.dataset.prOfferProduct = id;
        });
        this.observer.observe(main, {subtree: true, attributes: true, attributeFilter: ['aria-current']});
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
